var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"pagina"},[_c('div',{staticClass:"viewPagina"},[_c('Livro')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }